import { render, staticRenderFns } from "./FieldDescriptor.vue?vue&type=template&id=b34020f2&scoped=true"
import script from "./FieldDescriptor.vue?vue&type=script&lang=js"
export * from "./FieldDescriptor.vue?vue&type=script&lang=js"
import style0 from "./FieldDescriptor.vue?vue&type=style&index=0&id=b34020f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_babel-core@7.0.0-bridge.0_@babel+core@7.28._1eb1b9dda9fe6d233009820956254809/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34020f2",
  null
  
)

export default component.exports